import React, { Component } from "react";
import "./App.css";
import { Select, Input, Tag, Button, notification } from "antd";
import { v4 as uuidv4 } from "uuid";

const { Option } = Select;

const colors = [
	"magenta",
	"red",
	"volcano",
	"orange",
	"gold",
	"lime",
	"green",
	"cyan",
	"blue",
	"geekblue",
	"purple",
];

const topWebsites ={
	"topwebsites": [
		{
			id: "1",
			name: "google.com",
		},
		{
			id: "2",
			name: "youtube.com",
		},
		{
			id: "3",
			name: "facebook.com",
		},
		{
			id: "4",
			name: "baidu.com",
		},
		{
			id: "5",
			name: "wikipedia.com",
		},
		{
			id: "6",
			name: "twitter.com",
		},
		{
			id:"7",
			name:"yahoo.com",
		},
		{
			id:"8",
			name:"paypal.com",
		},
		{
			id:"9",
			name:"instagram.com",
		},
		{
			id:"10",
			name:"duckduckgo.com",
		},
		{
			id:"11",
			name:"yandex.ru",
		},
		{
			id:"12",
			name:"ampproject.org",
		},
		{
			id:"13",
			name:"cricbuzz.com"
		},
		{
			id:"14",
			name:"amazon.com",
		},
		{
			id:"15",
			name:"live.com",
		},
		{
			id:"16",
			name:"vk.com",
		},
		{
			id:"17",
			name:"netflix.com",
		},
		{
			id:"18",
			name:"qq.com",
		},
		{
			id:"19",
			name:"whatsapp.com",
		},
		{
			id:"20",
			name:"mail.ru",
		},
		{
			id:"21",
			name:"reddit.com",
		},
		{
			id:"22",
			name:"yahoo.co.jp",
		},
		{
			id:"23",
			name:"google.com.br",
		},
		{
			id:"24",
			name:"bing.com",
		},
		{
			id:"25",
			name:"ok.ru",
		},
		{
			id:"26",
			name:"xhamster.com",
		},
		{
			id:"27",
			name:"sogou.com",
		},
		{
			id:"28",
			name:"ebay.com",
		},
		{
			id:"29",
			name:"bit.ly",
		},
		{
			id:"30",
			name:"twitch.tv",
		},
		{
			id:"31",
			name:"linkedin.com",
		},
		{
			id:"32",
			name:"samsung.com",
		},
		{
			id:"33",
			name:"sm.cn",
		},
		{
			id:"34",
			name:"msn.com",
		},
		{
			id:"35",
			name:"office.com",
		},
		{
			id:"36",
			name:"globo.com",
		},
		{
			id:"37",
			name:"taobao.com",
		},
		{
			id:"38",
			name:"pinterest.com",
		},
		{
			id:"39",
			name:"google.de",
		},
		{
			id:"40",
			name:"microsoft.com",
		},
		{
			id:"41",
			name:"accuweather.com",
		},
		{
			id:"42",
			name:"naver.com",
		},
		{
			id:"43",
			name:"aliexpress.com",
		},
		{
			id:"44",
			name:"fandom.com",
		},
		{
			id:"45",
			name:"quora.com",
		},
		{
			id:"46",
			name:"github.com",
		},
		{
			id:"47",
			name:"imdb.com",
		},
		{
			id:"48",
			name:"uol.com.br",
		},
		{
			id:"49",
			name:"docomo.ne.jp",
		},
		{
			id:"50",
			name:"wordpress.com",
		}
	],
	"topsocialwebsites": [
		{
			id:"101",
			name:"facebook.com",
		},

		{
			id:"102",
			name:"youtube.com",
		},

		{
			id:"103",
			name:"myspace.com",
		},

		{
			id:"104",
			name:"twitter.com",
		},

		{
			id:"105",
			name:"flickr.com",
		},

		{
			id:"106",
			name:"photobucket.com",
		},

		{
			id:"107",
			name:"linkedin.com",
		},

		{
			id:"108",
			name:"digg.com",
		},

		{
			id:"109",
			name:"ning.com",
		},

		{
			id:"110",
			name:"yelp.com",
		},

		{
			id:"111",
			name:"tagged.com",
		},

		{
			id:"112",
			name:"squidoo.com",
		},

		{
			id:"113",
			name:"scribd.com",
		},

		{
			id:"114",
			name:"stumbleupon.com",
		},

		{
			id:"115",
			name:"hi5.com",
		},

		{
			id:"116",
			name:"bebo.com",
		},

		{
			id:"117",
			name:"reddit.com",
		},

		{
			id:"118",
			name:"myyearbook.com",
		},

		{
			id:"119",
			name:"technorati.com",
		},

		{
			id:"120",
			name:"kaboodle.com",
		},

		{
			id:"121",
			name:"friendster.com",
		},

		{
			id:"122",
			name:"flixter.com",
		},

		{
			id:"123",
			name:"xanga.com",
		},
		{
			id:"124",
			name:"epinions.com",
		},

		{
			id:"125",
			name:"plaxo.com",
		},

		{
			id:"126",
			name:"mybloglog.com",
		},

		{
			id:"127",
			name:"yuku.com",
		},


		{
			id:"128",
			name:"metafilter.com",
		},

		{
			id:"129",
			name:"blackplanet.com",
		},

		{
			id:"130",
			name:"care2.com",
		},

		{
			id:"131",
			name:"getsatisfaction.com",
		},

		{
			id:"132",
			name:"friendfeed.com",
		},

		{
			id:"133",
			name:"clipmarks.com",
		},

		{
			id:"134",
			name:"cafemom.com",
		},

		{
			id:"135",
			name:"newsvine.com",
		},

		{
			id:"136",
			name:"omgili.com",
		},

		{
			id:"137",
			name:"gigya.com",
		},

		{
			id:"138",
			name:"ballhype.com",
		},

		{
			id:"139",
			name:"current.com",
		},

		{
			id:"140",
			name:"revver.com",
		},

		{
			id:"141",
			name:"ping.com",
		},

		{
			id:"142",
			name:"tribe.com",
		},

		{
			id:"143",
			name:"magnify.com",
		},

		{
			id:"144",
			name:"diigo.com",
		},

		{
			id:"145",
			name:"dzone.com",
		},

		{
			id:"146",
			name:"xing.com",
		},

		{
			id:"147",
			name:"faves.com",
		},

		{
			id:"148",
			name:"twitpic.com",
		},

		{
			id:"149",
			name:"ecademy.com",
		},

		{
			id:"150",
			name:"twine.com",
		},

	],

	"topentertairmentwebsites":[
		{
			id:"201",
			name:"youtube.com",
		},
		{
			id:"202",
			name:"netflix.com",
		},
		{
			id:"203",
			name:"fandom.com",
		},
		{
			id:"204",
			name:"bilibili.com",
		},
		{
			id:"205",
			name:"imdb.com",
		},
		{
			id:"206",
			name:"archieveforwon.org",
		},
		{
			id:"207",
			name:"spotify.com",
		},
		{
			id:"208",
			name:"hotstar.com",
		},
		{
			id:"209",
			name:"disneyplus.com",
		},
		{
			id:"210",
			name:"worldstar.com",
		},
		{
			id:"211",
			name:"pixiv.net",
		},
		{
			id:"212",
			name:"hulu.com",
		},
		{
			id:"213",
			name:"syosetu.com",
		},
		{
			id:"214",
			name:"primevideo.com",
		},
		{
			id:"215",
			name:"wattpad.com",
		},
		{
			id:"216",
			name:"mangalelo.com",
		},
		{
			id:"217",
			name:"nicovideo.jp",
		},
		{
			id:"218",
			name:"dailymotion.com",
		},
		{
			id:"219",
			name:"animeflv.net",
		},
		{
			id:"220",
			name:"fanfiction.net",
		},
		{
			id:"221",
			name:"xfinity.com",
		},
		{
			id:"222",
			name:"douban.com",
		},
		{
			id:"223",
			name:"soundcloud.com",
		},
		{
			id:"224",
			name:"aparat.com",
		},
		{
			id:"225",
			name:"dcinside.com",
		},
		{
			id:"226",
			name:"twimg.com",
		},
		{
			id:"227",
			name:"grid.id",
		},
		{
			id:"228",
			name:"dmkt-sp.jp",
		},
		{
			id:"229",
			name:"nhk.or.jp",
		},
		{
			id:"230",
			name:"kinopoisk.ru",
		},
		{
			id:"231",
			name:"soundcloud.com",
		},
		{
			id:"232",
			name:"hbomax.com",
		},
		{
			id:"233",
			name:"screenrant.com",
		},
		{
			id:"234",
			name:"ytmp3.cc",
		},
		{
			id:"235",
			name:"mangakakalot.com ",
		},
		{
			id:"236",
			name:"deviantart.com",
		},
		{
			id:"237",
			name:"vimeo.com",
		},
		{
			id:"238",
			name:"genius.com",
		},
		{
			id:"239",
			name:"mediaset.it",
		},
		{
			id:"240",
			name:"9anime.to",
		},
		{
			id:"241",
			name:"pinimg.com",
		},
		{
			id:"242",
			name:"sky.com",
		},
		{
			id:"243",
			name:"tenki.jp",
		},
		{
			id:"244",
			name:"programme-tv.net",
		},
		{
			id:"245",
			name:"rezka.ag",
		},
		{
			id:"246",
			name:"npr.org",
		},
		{
			id:"247",
			name:"cuevana3.io",
		},
		{
			id:"248",
			name:"cmoa.jp",
		},
		{
			id:"249",
			name:"rumble.com",
		},
		{
			id:"250",
			name:"hitmo.me",
		},
		{
			id:"",
			name:"",
		},
		{
			id:"",
			name:"",
		},

	]
}

const entertainmentWebsites = [
	{
		id:"1",
		name:"qq.com",
	}
]

const openNotificationWithIcon = (type, message, description) => {
	notification[type]({
		message,
		description,
	});
};

export default class App extends Component {
	state = {
		websites: [],
		inputText: "topwebsites",
		preInputText: "https://",
		hashedValue: undefined,
		dropDownWebsites:topWebsites["topwebsites"],
		dropDownWebsites2: entertainmentWebsites
	};

	onSelectChange = (value) => {

		let data = topWebsites[value];

		switch(value){

			case "topwebsites":{

				this.setState({
					dropDownWebsites:data,
					inputText:value,
				})
				break;
			}
			case "topsocialwebsites":{
				this.setState({
					dropDownWebsites:data,
					inputText:value,
				})
				break;
			}
			case "topentertairmentwebsites":{
				this.setState({
					dropDownWebsites:data,
					inputText:value,
				})
				break;
			}
			default:{
				this.setState({
					dropDownWebsites:data,
					inputText:value,
				})
			}

		}

	};
	closeTag = (id) => {
		const websites = [...this.state.websites];
		let index = websites.findIndex((website) => website.id === id);
		websites.splice(index, 1);
		this.setState({
			websites,
		});
	};

	generateRandomIndex = () => {
		console.log("called");
		let max = 11;
		let min = 0;
		return Math.floor(Math.random() * (max - min + 1)) + min;
	};

	addWebsiteToState = () => {
		const websites = this.state.websites;
		const uniqueWebsites = new Set(websites);
		let inputText = this.state.inputText.replace(/(^\w+:|^)\/\//, "");
		const newId = uuidv4();
		uniqueWebsites.add({
			name: this.state.preInputText + inputText,
			id: newId,
		});
		this.setState(
			{
				websites: Array.from(uniqueWebsites),
				inputText: "",
			},
			() => {
				console.log(this.state);
			}
		);
	};
	handleInputChange = (e) => {
		this.setState({ inputText: e.target.value });
	};
	preInputChange = (value) => {
		this.setState({
			preInputText: value,
		});
	};

	toggleWebsiteSelection=(website)=>{
		const index = this.state.websites.findIndex((site)=>site.id===website.id);
		const isSelected = index !== -1;
		const websites = [...this.state.websites];
		if(!isSelected) websites.push(website);
		else{
			websites.splice(index,1);
		}
		this.setState({
			websites
		})
	}


	getHashedValue = () => {
		let concatednatedString = "";
		this.state.websites.forEach(
			(website) => (concatednatedString += website.name+'|' )
		);
		console.log(concatednatedString);
		fetch(
			"https://1a8k7k3vhh.execute-api.us-east-1.amazonaws.com/default/lambda_function?url=" +
			concatednatedString.substr(0,concatednatedString.length-1)
		)
			.then((response) => response.json())
			.then(({ message }) => {
				this.setState({
					hashedValue: message,
				});
			})

			.catch((err) =>
				openNotificationWithIcon("error", err.status, err.message)
			);
	};



	render() {
		const selectBefore = (
			<Select
				value={this.state.preInputText}
				className="select-before"
				onChange={this.preInputChange}
			>
				<Option value="http://">http://</Option>
				<Option value="https://">https://</Option>
			</Select>
		);

		return (
			<div className="app__wrapper">

				<div className="setLogo">
					<img className="logo" src="https://media-exp1.licdn.com/dms/image/C4D0BAQEkp_SOcNOdhw/company-logo_200_200/0/1596109210547?e=2159024400&v=beta&t=FMjrtqclQ7D7SAw-Tsj0d7_mErmjNY__J-6sPGyzVOE" alt="some error occured"/>
					<h1 className="heading">FLOC <span className="steal">SIMHASH</span> </h1>
				</div>
				<div className="app">
					<div className="dropdown-websites-container">

						<Select
							defaultValue="topwebsites"
							onChange={this.onSelectChange}
							value={this.state.inputText}
							className="select-website"
						>
							<Option value="topwebsites">Top Websites</Option>
							<Option value="topsocialwebsites">Top Social Websites</Option>
							<Option value="topentertairmentwebsites">
								Top Entertairment Websites
							</Option>
						</Select>

						<p className="choose-websites">Choose websites</p>
						{this.state.dropDownWebsites.map((website) => {
							const isSelected = this.state.websites.findIndex((site) => site.id === website.id) !== -1;

							return (
								<Button className="website" onClick={()=>this.toggleWebsiteSelection(website)} disabled={isSelected}>{website.name}</Button>
							)
						})}
					</div>

					<div className="orClass">
						<h3>
							OR
						</h3>
					</div>

					<div className="dropdown-websites-container">
						<p className="choose-websites">Enter Website Manually</p>
						<div className="text-container">
							<Input
								className="text"
								addonBefore={selectBefore}
								placeholder="Enter a website address"
								onPressEnter={this.addWebsiteToState}
								onChange={this.handleInputChange}
								value = {this.state.inputText === "topwebsites"? ""
									:this.state.inputText==="topsocialwebsites"?""
										:this.state.inputText==="topentertairmentwebsites"?""
											:this.state.inputText
								}
							/>
						</div>
					</div>

					<div className="dropdown-websites-container">
						<p className="choose-websites">Selected websites</p>
						<div className="selected-websites">
							{this.state.websites.map((website) => {
								const randomIndex = this.generateRandomIndex();
								return (
									<Tag
										closable
										color={colors[randomIndex]}
										className="tag"
										onClose={() => this.closeTag(website.id)}
										key={website.id}
									>
										{website.name}
									</Tag>
								);
							})}
						</div>
					</div>

					<div className="submit">
						<Button
							type="primary"
							className="submit-btn"
							onClick={this.getHashedValue}
						>
							Get Hashed Value
						</Button>
					</div>
					<h2 className="hashed-value"> {this.state.hashedValue && this.state.hashedValue!=="d41d8cd98f00b204e9800998ecf8427e"?this.state.hashedValue:"Please Select Or Enter A Website !!!"}</h2>
				</div>
			</div>
		);
	}
}
